import { useEffect, useState } from 'react'
import AuthService from 'services/auth'
import cutileiApi from 'services/cutileiApi'
import { WHATSAPP_ENABLED } from 'services/features'

/*
  A Gestão WhatsApp só aparece para salão liberado: a API guarda a liberação por salão
  (`access_granted` em `business_bot_settings`) e responde em `/whatsapp/access`. Fora dela
  (variável desligada, salão não liberado, erro de rede), o item some — o lado seguro do erro.

  Uma pergunta por salão enquanto a página está aberta: o menu aparece em toda tela.
*/
const cache = new Map()

export function fetchWhatsappAccess(businessId) {
  if (!WHATSAPP_ENABLED || !businessId) return Promise.resolve(false)
  if (!cache.has(businessId)) {
    const request = cutileiApi.get(`/businesses/${businessId}/whatsapp/access`)
      .then(({ data }) => data?.enabled === true)
      .catch(() => {
        cache.delete(businessId)
        return false
      })
    cache.set(businessId, request)
  }
  return cache.get(businessId)
}

/** Só para os testes: esquece as respostas guardadas. */
export function clearWhatsappAccess() {
  cache.clear()
}

/** true/false quando a API responde; undefined enquanto pergunta. */
export default function useWhatsappAccess() {
  const businessId = AuthService.isSigned() ? AuthService.getBusinessId() : null
  const [access, setAccess] = useState(undefined)

  useEffect(() => {
    let alive = true
    fetchWhatsappAccess(businessId).then(value => { if (alive) setAccess(value) })
    return () => { alive = false }
  }, [businessId])

  return access
}
